import {
  ODataHeader,
  ODataString,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
const headers = [
  new ODataHeader({
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Name"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("LogoBase64"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.logo",
    type: new ODataString("Translations[]/LogoBase64",{
      getHtml: (item, type) => {
        let p = translate2(item, "LogoBase64");
        return `<img
        :id="imgControlId"
        src="${p}"
        style="height:100px;cursor:pointer"
      />`;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/RefId"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Id"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
];
function getHeaders() {
  return headers;
}
export default getHeaders;
